/**
 * Escapes characters that are significant in an HTML element context so
 * that user text can be safely placed inside `dangerouslySetInnerHTML`.
 *
 * Forward slashes are intentionally left untouched so that downstream URL detection
 * (anchorme) still recognises links.
 */
const escapeHtml = (text: string): string =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#x27;');

export default escapeHtml;
